import { gql } from "@apollo/client";
import { isDateRangeIn, taxCalculation } from "./helper";
import { PURCHASABLE_BUFFER } from "@/lib/constants";
export const typeDef = gql`
  type Product {
    id: ID!
    name: String!
    thumbnailUrl: String
    description: String
    product_type: String
    sales_start_at: String
    sales_end_at: String
    price: Int
    priceWithoutTax: Int
    rightIds: [Int]
    purchased: Boolean
    right: Right
    meta: MediaMeta
    purchaseAllowed: Boolean
    voucherCode: VoucherCode
    discountPrice: Int
  }

  type Query {
    productById(id: Int): Product
  }
`;
export const resolvers = {
  Query: {
    productById: async (_parent, args, _ref) => {
      let {
        dataSources
      } = _ref;
      const res = await dataSources.product.productById(args);
      return res;
    }
  },
  Product: {
    id: product => product.id || product.product_id,
    thumbnailUrl: (product, _args, _ref2) => {
      let {
        req
      } = _ref2;
      const noimage = "/images/noimage.png";
      return product.thumbnail_url || noimage;
    },
    price: product => {
      var _product$active_prici;
      return product === null || product === void 0 || (_product$active_prici = product.active_pricing) === null || _product$active_prici === void 0 ? void 0 : _product$active_prici.payment_amount;
    },
    priceWithoutTax: product => {
      var _product$active_prici2;
      return product === null || product === void 0 || (_product$active_prici2 = product.active_pricing) === null || _product$active_prici2 === void 0 ? void 0 : _product$active_prici2.price;
    },
    rightIds: product => product === null || product === void 0 ? void 0 : product.right_ids,
    purchased: async (product, _args, _ref3) => {
      let {
        req,
        dataSources
      } = _ref3;
      if (!req.userToken) return false;
      if (!product.ref_id) return false;
      const right = await dataSources.right.rightsByRefId(product.ref_id);
      const rightId = right.right_id;
      const {
        entitlements
      } = await dataSources.user.entitlementsFromRight([rightId]);
      return entitlements && entitlements.length > 0 ? true : false;
    },
    right: async (product, _args, _ref4) => {
      let {
        dataSources
      } = _ref4;
      const right = await dataSources.right.rightsByRefId(product.ref_id);
      return right;
    },
    meta: async (product, _args, _ref5) => {
      let {
        dataSources
      } = _ref5;
      const right = await dataSources.right.rightsByRefId(product.ref_id);
      if (right) {
        var _res$metas;
        const res = await dataSources.meta.searchFromRightId(right.right_id);
        return res === null || res === void 0 || (_res$metas = res.metas) === null || _res$metas === void 0 ? void 0 : _res$metas[0];
      } else {
        return null;
      }
    },
    purchaseAllowed: product => {
      return isDateRangeIn(product === null || product === void 0 ? void 0 : product.sales_start_at, product === null || product === void 0 ? void 0 : product.sales_end_at, {
        buffer: PURCHASABLE_BUFFER,
        default: true
      });
    },
    voucherCode: product => product === null || product === void 0 ? void 0 : product.voucher_code,
    discountPrice: product => {
      if (product !== null && product !== void 0 && product.voucher_code) {
        const discount = product.voucher_code.voucher.discount_price;
        const price = product.active_pricing.price;
        if (price <= discount) {
          return 0;
        }
        return taxCalculation(price - discount);
      }
      return null;
    }
  }
};